export default "__VITE_ASSET__6a548734__"